  (function() {
    const pagePath = "/pages/my-capsules";

    // Clear cart then refresh
    function clearCartAndRefresh() {
      fetch('/cart/clear.js', { method: 'POST' })
        .finally(() => {
          sessionStorage.setItem("myCapsulesRefreshed", "true");
          window.location.reload();
        });
    }

    // Run on load
    function maybeRefresh() {
      if (window.location.pathname === pagePath) {
        if (!sessionStorage.getItem("myCapsulesRefreshed")) {
          clearCartAndRefresh();
        }
      }
    }

    maybeRefresh();

    // Handle back/forward navigation (bfcache restore)
    window.addEventListener("pageshow", function(event) {
      if (event.persisted) {
        sessionStorage.removeItem("myCapsulesRefreshed");
        maybeRefresh();
      }
    });
  })();